module.exports = __webpack_public_path__ + "img/TFT.992a6af1.jpg";